import { toast, cssTransition, ToastContainer } from 'react-toastify'

export function notiSuccess(title?: string, option?: string, url?: any, callback?: any, toastClassName?: string, history?: any) {
  toast.success(title, {
    position: 'bottom-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: toastClassName || '',
    onClose: () => {
      if (option === 'reset') {
      } else if (option === 'reload') {
        window.location.reload()
      } else if (option === 'go') {
        if (history) {
          history.push(url)
        } else {
          window.location.href = url
        }
      } else if (callback != null) callback(true)
    }
  })
}

export function notiError(title?: string, option?: string, url?: any, callback?: any, toastClassName?: string, history?: any) {
  toast.error(title, {
    position: 'bottom-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: toastClassName || '',
    onClose: () => {
      if (option === 'reset') {
      } else if (option === 'reload') {
        window.location.reload()
      } else if (option === 'go') {
        /** history เป็น optional param ตัวสุดท้ายเหมือน notiSuccess ไม่ส่งมาก็ยังโหลดหน้าใหม่เหมือนเดิมทุกประการ */
        if (history) {
          history.push(url)
        } else {
          window.location.href = url
        }
      } else if (callback != null) callback(true)
    }
  })
}

const slide = cssTransition({
  enter: 'slide-in',
  exit: 'slide-out'
})

export function notiPopup(status: 'success' | 'warning' | 'custom' | 'clear', title?: string, customToast?: any, callback?: any,) {
  if (status === 'clear') {
    toast.dismiss()
  } else {
    if (status === 'success') {
      toast.success(title, {
        containerId: 'popup',
        position: 'top-center',
        transition: slide,
        autoClose: 3000,
        hideProgressBar: true
      })
    } else if (status === 'custom') {
      toast.info(customToast, {
        containerId: 'popup',
        position: 'top-center',
        transition: slide,
        closeButton: false,
        autoClose: false,
        closeOnClick: false,
        hideProgressBar: true,
        draggable: false,
        className: 'toast-custom'
      })
    } else if (callback != null) {
      callback(true)
    } else {
      toast.info(title, {
        containerId: 'popup',
        position: 'top-center',
        transition: slide,
        autoClose: 3000,
        hideProgressBar: true
      })
    }
  }
}




type ConfirmToastProps = {
  message: string;
  onConfirm: () => void;
  onCancel?: () => void;
};

export const ConfirmToast = ({
  message,
  onConfirm,
  onCancel,
}: ConfirmToastProps) => {
  return (
    <div className="p-2">
      <p className="mb-3">{message}</p>

      <div className="d-flex gap-2 justify-content-end">
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={() => {
            onCancel?.();
            toast.dismiss();
          }}
        >
          ยกเลิก
        </button>

        <button
          type="button"
          className="btn btn-success btn-sm"
          onClick={() => {
            onConfirm();
            toast.dismiss();
          }}
        >
          ยืนยัน
        </button>
      </div>
    </div>
  );
};